module.exports = __webpack_public_path__ + "static/media/michael_shi.cf579bb7.png";